import { displayShortDate } from '../../utils/Format/Format';

export const lipperRankingUtil = (gqlResult) => {
    if (!gqlResult) return null;
    const {
        mutualFund: {
            lipperRanking: {
                oneYearAverageAnnualTotalReturnsRankDesc,
                threeYearAverageAnnualTotalReturnsRankDesc,
                fiveYearAverageAnnualTotalReturnsRankDesc,
                tenYearAverageAnnualTotalReturnsRankDesc,
                sinceInceptionTotalReturnsRankDesc,
                asOfDate
            },
            inceptionDate
        }
    } = gqlResult;
    const title = 'Lipper Rankings';
    // lipper category name parameter needs to be added to query
    // const categoryTitle = 'LIPPER CATEGORY';
    const returnData = [
        {
            label: '1 Year',
            values: [{ val1: oneYearAverageAnnualTotalReturnsRankDesc }]
        },
        {
            label: '3 Years',
            values: [
                {
                    val1: threeYearAverageAnnualTotalReturnsRankDesc
                }
            ]
        },
        {
            label: '5 Years',
            values: [
                {
                    val1: fiveYearAverageAnnualTotalReturnsRankDesc
                }
            ]
        },
        {
            label: '10 Years',
            values: [{ val1: tenYearAverageAnnualTotalReturnsRankDesc }]
        },
        {
            label: `Since Inception (${displayShortDate(inceptionDate)})`,
            values: [{ val1: sinceInceptionTotalReturnsRankDesc }]
        }
    ];
    return {
        data: returnData,
        title,
        asOfDate: asOfDate ? displayShortDate(asOfDate) : ''
    };
};
